import React, { useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import { codigosSubcompetencia, valorNormalizado } from "../../utils/subcompetencias";
import { formatNota as fmt } from "../../utils/formato";

const TablaHistoricoPruebas = ({ filas }) => {
  const { rows, promedio, codigos } = useMemo(() => {
    if (!Array.isArray(filas) || !filas.length) {
      return { rows: [], promedio: null, codigos: [] };
    }
    // El número de columnas de subcompetencia varía por competencia
    // (RC/LC: C1-C3, CC: C1-C7), así que se descubren en vez de asumir C1-C3.
    const codigos = codigosSubcompetencia(filas);
    const list = filas.map((r) => ({
      id: r.id,
      label: `${r.Prueba || "Prueba"} (${r.anio}-${r.semestre})`,
      valores: codigos.map((c) => valorNormalizado(r, c)),
      total: r.Total,
    }));
    const sum = list.reduce((s, r) => s + (Number(r.total) || 0), 0);
    return {
      rows: list,
      promedio: list.length ? Number((sum / list.length).toFixed(2)) : null,
      codigos,
    };
  }, [filas]);

  const columnasGrid = `2fr ${codigos.map(() => "0.7fr").join(" ")} 0.8fr`.trim();

  if (!rows.length) {
    return (
      <Box bgcolor="#ffffff" borderRadius={12} boxShadow="0 1px 8px rgba(0, 0, 0, 0.08)" p={1.25}>
        <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0f172a" }}>
          Histórico de pruebas
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
          Ingresa un correo con resultados para este periodo.
        </Typography>
      </Box>
    );
  }

  return (
    <Box bgcolor="#ffffff" borderRadius={12} boxShadow="0 1px 8px rgba(0, 0, 0, 0.08)" p={1.25}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.75}>
        <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0f172a" }}>
          Histórico de pruebas
        </Typography>
        <HistoryIcon style={{ color: "#64748b", fontSize: 20 }} />
      </Box>
      <Box style={{ overflowX: "auto" }}>
        <Box style={{ minWidth: codigos.length > 3 ? codigos.length * 70 + 200 : "auto" }}>
          <Box
            style={{
              display: "grid",
              gridTemplateColumns: columnasGrid,
              fontWeight: 700,
              padding: "6px 8px",
              fontSize: 12,
              borderBottom: "2px solid #e5e7eb",
              background: "#f8fafc",
            }}
          >
            <span>Prueba</span>
            {codigos.map((c) => (
              <span key={c}>{c}</span>
            ))}
            <span>Total</span>
          </Box>
          <Box style={{ maxHeight: 200, overflowY: "auto" }}>
            {rows.map((r) => (
              <Box
                key={r.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: columnasGrid,
                  padding: "6px 8px",
                  fontSize: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <span>{r.label}</span>
                {r.valores.map((v, i) => (
                  <span key={codigos[i]}>{fmt(v)}</span>
                ))}
                <span>{fmt(r.total)}</span>
              </Box>
            ))}
          </Box>
          <Box
            style={{
              display: "grid",
              gridTemplateColumns: columnasGrid,
              padding: "8px",
              fontSize: 12,
              fontWeight: 800,
              background: "#f1f5f9",
              marginTop: 4,
              borderRadius: 8,
            }}
          >
            <span>Promedio final</span>
            {codigos.map((c) => (
              <span key={c} />
            ))}
            <span>{promedio != null ? fmt(promedio) : "—"}</span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TablaHistoricoPruebas;
